import { z } from "zod"

import { TabsList, TabsRoot, TabsTrigger } from "~/components/reusable/Tabs"
import { useSafeLocalStorage } from "~/hooks/useSafeLocalStorage"
import { trackEvent } from "~/hooks/useTrackingService"

export type ForecastValueMode = "gross" | "net"

const ForecastValueModeSchema = z.enum(["gross", "net"])

// Gross = forecast as-is; Net = forecast × (1 - returnRate), read-only derived view.
// Shared across the Forecast Updates screen and the Review variants dialog.
export function useForecastValueMode() {
  return useSafeLocalStorage<ForecastValueMode>(
    "forecast-value-mode",
    "gross",
    ForecastValueModeSchema,
  )
}

export const ForecastValueModeButton = ({
  mode,
  onModeChange,
}: {
  mode: ForecastValueMode
  onModeChange: (mode: ForecastValueMode) => void
}) => {
  const handleChange = (newMode: ForecastValueMode) => {
    if (newMode === mode) return
    trackEvent("Forecast Value Mode Toggled", {
      "Value Mode": newMode === "net" ? "Net" : "Gross",
    })
    onModeChange(newMode)
  }

  return (
    <TabsRoot
      value={mode}
      onValueChange={(value) => handleChange(value === "net" ? "net" : "gross")}
    >
      <TabsList size="sm">
        <TabsTrigger size="sm" value="gross">
          Gross
        </TabsTrigger>
        <TabsTrigger size="sm" value="net">
          Net
        </TabsTrigger>
      </TabsList>
    </TabsRoot>
  )
}
